import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { ModalContainer } from "../../modal-container"
import { AuthenticationLayout, LoginPage, RequestNewPasswordPage, UnitSearchPage, NotFoundPage } from "../../pages"
import { WorkspaceLayout, DashboardPage, ProjectExports, ProjectListPage, DataEnrichmentPage, SettingsPage, DataSciencePage, DataScienceModelDetailsPage } from "../../pages/workspace"
import { ProjectDetailsPage } from "../../pages/workspace/project-details"
import { UnitSearchPjDetailsPage } from "../../pages/workspace/unit-search/unit-search-pj-details"
import { PrivateRoute } from "../private-route"
import { UnknownError } from "../../pages/unknown-error"
import { BackofficePage } from "../../pages/workspace/backoffice"
import { TwoFactorPage } from "../../pages/authentication/two-factor/TwoFactorPage"
import { TwoFactorVerifyPage } from "../../pages/authentication/two-factor/TwoFactorVerifyPage"
import { TwoFactorActivationPage } from "../../pages/authentication/two-factor/TwoFactorActivationPage"

export const MainRouter = () => {
  return (
    <>
      <BrowserRouter>
        <ModalContainer />
        <Routes>
          <Route path="/" element={
            <Navigate to="/workspace" />
          } />
          <Route path="authentication" element={<AuthenticationLayout />}>
            <Route path="" element={<Navigate to="/authentication/login" />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="request-new-password" element={<RequestNewPasswordPage />} />
          </Route>
          <Route path="workspace" element={<WorkspaceLayout />}>
            <Route path="" element={<>
              <PrivateRoute>
                <DashboardPage />
              </PrivateRoute>
            </>} />
            <Route path="data-science" element={<>
              <PrivateRoute>
                <DataSciencePage />
              </PrivateRoute>
            </>} />
            <Route  path="data-science/details" element={<>
              <PrivateRoute>
                <DataScienceModelDetailsPage />
              </PrivateRoute>
            </>} />
            <Route path="project-exports" element={<>
              <PrivateRoute>
                <ProjectExports />
              </PrivateRoute>
            </>} />
            <Route path="projects" element={<>
              <PrivateRoute>
                <ProjectListPage />
              </PrivateRoute>
            </>} />
            <Route path="projects/details" element={<>
              <PrivateRoute>
                <ProjectDetailsPage />
              </PrivateRoute>
            </>} />
            <Route path="data-enrichment" element={<>
              <PrivateRoute>
                <DataEnrichmentPage />
              </PrivateRoute>
            </>} />
            <Route path="unit-search" element={<>
              <PrivateRoute>
                <UnitSearchPage />
              </PrivateRoute>
            </>} />
            <Route path="unit-search/details" element={<>
              <PrivateRoute>
                <UnitSearchPjDetailsPage />
              </PrivateRoute>
            </>} />
            <Route path="settings" element={<>
              <PrivateRoute>
                <SettingsPage />
              </PrivateRoute>
            </>} />
            <Route path="backoffice" element={<>
              <PrivateRoute>
                <BackofficePage />
              </PrivateRoute>
            </>} />
          </Route>
          <Route 
                path="/two-factor" 
                element={
                  <PrivateRoute>
                    <TwoFactorPage />
                  </PrivateRoute>
                } 
              />
          <Route 
  path="/authentication/two-factor-verify" 
  element={
      <TwoFactorVerifyPage />
  } 
/>
<Route 
  path="/authentication/two-factor-activation" 
  element={
      <TwoFactorActivationPage />
  } 
/>
          <Route path="/unknown-error" element={<UnknownError />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </>
  )
}